const userKey = '_nscorporate_user';
const INITIAL_STATE = {
    user: JSON.parse(sessionStorage.getItem(userKey)),
    validated: false,
    validToken: false,
    isAuthenticated: false,
    sucesso: false,
    alterpwd: false,
    provisionalLogin: false,
    hashIsValid: false,
    validatingHash: true,
    cpfLoginValidated: false,
    validatingCpfLogin: true,
    errorCode: "",
    hashChecked: false,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TOKEN_VALIDATED':
            if (action.payload) {
                return { ...state, validToken: true }
            } else {
                sessionStorage.removeItem(userKey)
                return { ...state, validToken: false, user: null, isAuthenticated: false }
            }
        case 'USER_FETCHED':
            sessionStorage.setItem(userKey, JSON.stringify(action.payload))
            return { ...state, user: action.payload, validToken: true,
                    isAuthenticated: true, alterpwd: action.payload.alterpwd, provisionalLogin: action.payload.provisionalLogin }
        case 'USER_VALIDATED':
            return { ...state, validated: action.payload, sucesso: action.sucesso }
        case 'CPF_LOGIN_VALIDATING':
            return { ...state, validatingCpfLogin: true, cpfLoginValidated: false, sucesso: action.sucesso, errorCode: "" }
        case 'CPF_LOGIN_VALIDATED':
            return { ...state, validatingCpfLogin: false, cpfLoginValidated: action.payload.retorno, sucesso: action.sucesso, errorCode: action.payload.errorCode }
        case 'HASH_VALIDATING':
            return { ...state, validatingHash: true };
        case 'HASH_VALIDATED':
            return { ...state, validatingHash: false, hashChecked: true, hashIsValid: action.payload };
        case 'RESET':
            return { ...state, validated: false, sucesso: false }
        default:
            return state
    }
}
